export default __webpack_public_path__ + "static/media/secured.925c62a2.png";